module.exports = require("url");


//////////////////
// WEBPACK FOOTER
// external "url"
// module id = 8
// module chunks = 0 1